import { LeanAlert } from "lean-components/LeanComponents"
import { useTranslator } from "lean-util/LeanTranslator"
import { UIDataTableCellActions } from "components"

const useColumns = (onEdit, onDelete) =>
{
    // MARK: - Properties

    const { translate } = useTranslator()


    // MARK: - Methods

    return [
        {
            accessorKey: "name",
            header: () => translate("name"),
            cell: info => info.getValue()
        },
        {
            accessorKey: "url",
            header: () => translate("url"),
            cell: info => info.getValue()
        },
        {
          accessorKey: "platform",
          header: () => translate("platform"),
          cell: info => info.getValue()
        }
    ]
}

export { useColumns }
